import type { PregnancySnapshot } from '../lib/pregnancy';
import { getWeekGuide, localizedFruit, localizedTip } from '../data/weeks';
import { useLanguage } from '../i18n/context';
import { getUi } from '../i18n/ui';
import { Mascot } from './mascots';
import styles from '../App.module.css';

interface WeekCardProps {
  snapshot: PregnancySnapshot;
}

export function WeekCard({ snapshot }: WeekCardProps) {
  const { locale } = useLanguage();
  const ui = getUi(locale);

  if (snapshot.mode === 'unset') return null;

  if (snapshot.mode === 'postpartum') {
    return (
      <section className={styles.weekCard} aria-labelledby="week-card-title">
        <div className={styles.weekHeader}>
          <Mascot id="sleep" size={44} />
          <div>
            <h2 id="week-card-title" className={styles.weekTitle}>
              {ui.weekCard.postpartumTitle}
            </h2>
            <p className={styles.weekLabel}>{snapshot.label}</p>
          </div>
        </div>
        <p className={styles.weekTip}>{ui.weekCard.postpartumTip}</p>
      </section>
    );
  }

  const week = snapshot.gestationalWeeks ?? 0;
  const guide = getWeekGuide(week);
  if (!guide) return null;

  return (
    <section className={styles.weekCard} aria-labelledby="week-card-title">
      <div className={styles.weekHeader}>
        <Mascot id="star" size={44} />
        <div>
          <h2 id="week-card-title" className={styles.weekTitle}>
            {ui.weekCard.title
              .replace('{week}', String(guide.week))
              .replace('{days}', String(snapshot.gestationalDays ?? 0))}
          </h2>
          <p className={styles.weekLabel}>{snapshot.label}</p>
        </div>
      </div>
      <div className={styles.weekFacts}>
        <div className={styles.weekFact}>
          <span className={styles.weekFactLabel}>{ui.weekCard.sizeLabel}</span>
          <span className={styles.weekFactValue}>
            {ui.weekCard.fruitLike.replace('{fruit}', localizedFruit(guide, locale))}
          </span>
          <span className={styles.weekFactMeta}>{guide.sizeCm}</span>
        </div>
      </div>
      <p className={styles.weekTip}>{localizedTip(guide, locale)}</p>
      <p className={styles.weekDisclaimer}>{ui.weekCard.disclaimer}</p>
    </section>
  );
}
